<template><NumberRangeFilter field="porosity" label="Пористость" @filter="$emit('filter',$event)"/></template>
<script>
import NumberRangeFilter from './NumberRangeFilter.vue'
export default { name:'PorosityFilter', components:{NumberRangeFilter} }
</script>
